import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage } from '../firebase.config';

async function uploadImage(file: File, userId: string): Promise<string | null> {
    const DEFAULT_IMAGE_URL = 'https://cdn.vectorstock.com/i/1000v/62/96/family-tree-template-design-vector-33836296.jpg';

    try {
        const storageRef = ref(storage, `boards/${userId}/${file.name}`);
        await uploadBytes(storageRef, file);
        const downloadURL = await getDownloadURL(storageRef);
        return downloadURL;
    } catch (error) {
        console.error('Error uploading image:', error);
        return DEFAULT_IMAGE_URL;
    }
}

export default uploadImage;
